import {
  IAccountSummary,
  IReportDatasetLens,
  MultiHierarchyAccountSummary,
  getLensIdsFromReport
} from '@opengov/reporting-types';
import { create } from 'zustand';
import * as api from './reportingApi';

interface LensStore {
  items: Record<string, IReportDatasetLens>;
}

const store = create<LensStore>(() => ({
  items: {}
}));

export async function getLensesForReport(
  report: IAccountSummary | MultiHierarchyAccountSummary,
  reportConfigurationId: string
) {
  const lensIds = getLensIdsFromReport(report);

  const state = store.getState();
  const missingLensIds: string[] = [];

  lensIds.forEach((id) => !state.items[id] && missingLensIds.push(id));
  if (missingLensIds?.length > 0) {
    const missingLenses = (
      await api.getDatasetSchemas({ ids: missingLensIds, reportConfigurationId, options: { metadata: true } })
    ).data;

    store.setState((state) => {
      Object.assign(state.items, missingLenses);
      return { ...state };
    });
  }

  const items = store.getState().items;
  return items;
}
